/**
 * structured-carousel
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_structured-carousel.twig';
import './_structured-carousel.css';

export const name = 'structured-carousel';

export const defaults = {
  dummyClass: 'js-structured-carousel-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { structuredCarousel = {} }) {
  // Find our component within the DOM
  const $structuredCarousel = $('.structured-carousel', $context);
  // Bail if component does not exist
  if (!$structuredCarousel.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...structuredCarousel,
  };
  // An example of what could be done with this component
  $structuredCarousel.addClass(settings.dummyClass);
}

function cardOpenBehaviour() {
  $('.structured-slides-card-item').on('click', function() {
    /* close all open 1 */
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
    }
    else {
      $('.structured-slides-card-item.open').removeClass('open');
      $(this).toggleClass('open');
    }
  });
}

function structuredCarouselBehaviour() {
  /* set total slides */ 
  const totalSlides = $('.slick--optionset--structured-carousel .slick-dots li').length;  

  /* add total slides into slick dots */
  $('.slick-dots').append('<div class="slick-dots-total"><span class="slick-dots-total-divider">/</span>' + '<span class="slick-dots-total-number">' + totalSlides + '</span></div>');

  /* change button text once on load */
  var firstLoadText = $('.slick--optionset--structured-carousel .slick-current').next().find('.structured-carousel__title').html();
  $('.slick--optionset--structured-carousel .slick__arrow-text-next').html(firstLoadText);

  /* change arrow button text */
  $('button.slick-arrow').on('click', function() {
    /* get next slide */
    var nextSlide = $('.slick--optionset--structured-carousel .slick-current');
    /* if theres next slide */ 
    if (nextSlide.next()) {
      /* set next arrow text */ 
      $('.slick--optionset--structured-carousel .slick__arrow-text-next').html(nextSlide.next().find('.structured-carousel__title').html());
    }
    /* if theres prev slide */ 
    if (nextSlide.prev()) {
      /* set prev arrow text */ 
      $('.slick--optionset--structured-carousel .slick__arrow-text-prev').html(nextSlide.prev().find('.structured-carousel__title').html());
    }
  });
  
}


/* Run when document is ready */
$(document).ready(function() {
  cardOpenBehaviour();
  structuredCarouselBehaviour();
});

export default enable;
